// @ts-nocheck
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { LIVE_DEMO_ICONS } from '../data/icons';
import TopBar from '../../components/layout/TopBar';
import type { CSSProperties } from 'react';

export function Icon({
  name,
  className = "",
  style,
}: {
  name: string;
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <svg
      className={className}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      dangerouslySetInnerHTML={{ __html: LIVE_DEMO_ICONS[name] || "" }}
    />
  );
}

export function Mark({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 64 64" fill="none">
      <rect x="6" y="16" width="42" height="42" rx="10" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinejoin="round" />
      <path d="M50 4 L53.2 14.8 L64 18 L53.2 21.2 L50 32 L46.8 21.2 L36 18 L46.8 14.8 Z" fill="#1769FF" />
    </svg>
  );
}

export function LiveDemoTopBar({ now }: { now?: string }) {
  const navigate = useNavigate();

  return <TopBar crumbTitle={now || "Live Demo Setup"} onHome={() => navigate('/admissions')} />;
}

const STEPS = ["Session", "Student & Parent", "Assessment", "Preparing demo"];

export function Stepper({ active }: { active: number }) {
  return (
    <div className="stepper">
      {STEPS.map((step, index) => (
        <FragmentStep key={step} step={step} index={index} active={active} />
      ))}
    </div>
  );
}

function FragmentStep({ step, index, active }: { step: string; index: number; active: number }) {
  return (
    <>
      {index > 0 && <div className={"step-line" + (index <= active ? " done" : "")} />}
      <div className={"step" + (index < active ? " done" : index === active ? " active" : "")}>
        <span className="dot">{index < active ? <Icon name="check" /> : index + 1}</span>
        {step}
      </div>
    </>
  );
}
